module.exports = __webpack_public_path__ + "img/attendance-reports.5655a6b0.webp";